import { render } from "./PeoductIntroduce.vue?vue&type=template&id=f091e782&scoped=true"
import script from "./PeoductIntroduce.vue?vue&type=script&lang=js"
export * from "./PeoductIntroduce.vue?vue&type=script&lang=js"

import "./PeoductIntroduce.vue?vue&type=style&index=0&id=f091e782&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f091e782"]])

export default __exports__